module.exports = __webpack_public_path__ + "img/6_135.85ceb297.png";